import { Toaster as Sonner, toast } from "sonner"

const Toaster = (props) => (
  <Sonner theme="light" position="top-center" offset={80} mobileOffset={{ top: 76, left: 16, right: 16 }}
    closeButton visibleToasts={3} duration={6000} containerAriaLabel="Notifications" className="toaster"
    toastOptions={{
      closeButtonAriaLabel: "Dismiss notice",
      classNames: { toast: "notice-toast", description: "notice-description" },
      style: { background: "#ffffff", color: "#111111", border: "1px solid #cbd5e1", borderRadius: "12px",
        boxShadow: "0 12px 32px rgba(15,23,42,0.24)", padding: "16px 48px 16px 18px", fontSize: "14px" },
      actionButtonStyle: { background: "#111111", color: "#ffffff" },
      cancelButtonStyle: { background: "#e2e8f0", color: "#111111" },
    }} {...props} />
)

export { Toaster, toast }
